import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ContentTypeInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method !== 'GET' && !request.headers.has('Content-Type')) {
      request = request.clone({ setHeaders: { 'Content-Type': 'application/vnd.api+json' } });
    }
    return next.handle(request);
  }
}
